import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { useAutoConfirmCountdown } from '@/shared/hooks';
import { AlertDialog } from '@/ui_v3';
const AUTO_REDIRECT_SECONDS = 3;
interface LoginRequiredDialogProps {
  /** dim 클릭 또는 확인/자동 이동 직후 다이얼로그를 닫는다. */
  onClose: () => void;
  /** 버튼 클릭 또는 카운트다운 종료 시 호출된다 (로그인 리다이렉트). */
  onConfirm: () => void;
}
function LoginRequiredDialog({
  onClose,
  onConfirm
}: LoginRequiredDialogProps) {
  const {
    t
  } = useTranslation(['common']);
  const {
    secondsLeft
  } = useAutoConfirmCountdown({
    seconds: AUTO_REDIRECT_SECONDS,
    onExpire: () => {
      onConfirm();
      onClose();
    }
  });
  return <AlertDialog onClose={confirmed => {
    if (confirmed === true) onConfirm();
    onClose();
  }} size="xs" header={{
    topSlot: '🙋',
    title: t('loginRequired.title')
  }} body={t('classroomJoin.loginRequired.body')} confirmText={t('loginRequired.confirm', {
    seconds: secondsLeft
  })} confirmIntent="strong" shouldCloseOnDimClick data-sentry-element="AlertDialog" data-sentry-component="LoginRequiredDialog" data-sentry-source-file="LoginRequiredDialog.tsx" />;
}

/**
 * 비로그인 사용자가 클래스 코드로 입장하려 할 때 띄우는 로그인 안내 다이얼로그.
 * 버튼 라벨이 3초 → 2초 → 1초로 카운트다운되며, 0이 되면 `onConfirm`(로그인 이동)을
 * 자동 실행한다. 버튼 클릭 시 즉시 이동, dim 클릭으로 닫으면 이동을 취소한다.
 */
export function openLoginRequiredDialog(onConfirm: () => void) {
  overlay.open(({
    unmount
  }) => <LoginRequiredDialog onClose={unmount} onConfirm={onConfirm} />);
}